import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import PhraseInContextEditorPostProcessor from 'i18next-phrase-in-context-editor-post-processor';
import { initReactI18next } from 'react-i18next';
import { world as w, namespaceExists, getLang } from './languages';
import { storageKeys } from './utils/browser-storage/storage-keys';
import serializeQueryParams from './utils/url/serialize-query-params';

const world = getLang() ?? w;

const checkForInlineEditor = () => {
    const params = serializeQueryParams();

    if (params.runPhraseEditor) {
        window.storage.setItem(storageKeys.general.phraseEditor, String(true));
    }

    if (params.stopPhraseEditor) {
        window.storage.removeItem(storageKeys.general.phraseEditor);
    }

    return Boolean(window.storage.getItem(storageKeys.general.phraseEditor));
};

i18n.use(Backend)
    .use(initReactI18next)
    .use(
        new PhraseInContextEditorPostProcessor({
            accountId: '1be2dd87c9a365ee7792688314f848e0',
            autoLowercase: false,
            fullReparse: true,
            phraseEnabled: checkForInlineEditor(),
            projectId: 'e7632bb4ba3b25327802db9be87f13d6'
        })
    )
    .init({
        debug: false,
        // we used fallbackNS for cases when translation function is called not from component with bound namespace, but from external file ---> and in this case function i18n.t will search in these files. This fix helps Phrase's "inContextEditor" understand keys (keys like namespace:key were ignored)
        fallbackNS: [
            'meta',
            'header',
            'search',
            'author-page',
            'common',
            'seller',
            'material-page',
            'footer',
            'cabinet-materials',
            'cabinet-settings'
        ],

        interpolation: {
            escapeValue: false
        },

        lng: world,

        postProcess: ['phraseInContextEditor'],
        resources: {}
    });

// Fix to make react-router provider loading correctly because it had been failed in MetaWrapper component
if (!namespaceExists('meta')) {
    import(`./languages/${world}/meta.json`).then(({ default: data }) => {
        if (i18n.addResourceBundle) {
            i18n.addResourceBundle(world, 'meta', data);
        }
    });
}

window.i18n = i18n;

export default i18n;
